<template>
  <div class="container-lg">
    <ModalCrud id="modalcrud" ref="modal" :permiteEliminar="false" :facade="Facade" :grande="true" v-on:evento-eliminar="eliminado($event)"
      v-on:evento-guardar="guardado($event)" @on-saving-error="onSavingError">
      <template slot="titulo">Beneficio</template>
      <template v-slot:default="slotProps">
        <FormularioBeneficio ref="formularioBeneficio" :comercioFijo="true" :facade="Facade" :item="slotProps.item"
          :permitePrioridad="false" :esAdmin="false"></FormularioBeneficio>
      </template>
    </ModalCrud>
    <!-- Acciones -->
    <div class="acciones-panel">
      <button @click="nuevo()" type="button" class="btn btn-success">
        <font-awesome-icon class="icono-izquierda" :icon="Icons.AGREGAR" />
        <span>Nuevo</span>
      </button>
    </div>
    <!--Tabs-->
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="aprobados-tab" data-bs-toggle="tab" href="#aprobados" role="tab"
          aria-controls="aprobados" aria-selected="false">Aprobados</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="pendientes-tab" data-bs-toggle="tab" href="#pendientes" role="tab"
          aria-controls="pendientes" aria-selected="true">Pendientes</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="rechazados-tab" data-bs-toggle="tab" href="#rechazados" role="tab"
          aria-controls="rechazados" aria-selected="false">Rechazados</a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <!-- Aprobados -->
      <div class="tab-pane fade show active tab-aprobados" id="aprobados" role="tabpanel"
        aria-labelledby="aprobados-tab">
        <Tabla ref="tablaAprobados" :columnas="Columnas" :facade="Facade" v-on:evento-item-elegido="abrir($event)">
        </Tabla>
      </div>
      <!-- Pendientes -->
      <div class="tab-pane fade tab-pendientes" id="pendientes" role="tabpanel" aria-labelledby="pendientes-tab">
        <Tabla ref="tablaPendientes" :columnas="Columnas" :facade="PendingFacade"
          v-on:evento-item-elegido="abrir($event)"></Tabla>
      </div>
      <!-- Rechazados -->
      <div class="tab-pane fade tab-rechazados" id="rechazados" role="tabpanel" aria-labelledby="rechazados-tab">
        <Tabla ref="tablaRechazados" :columnas="ColumnasRechazados" :facade="RechazadosFacade"
          v-on:evento-item-elegido="abrir($event)"></Tabla>
      </div>
    </div>
    <div class="alert alert-secondary alert-dismissible fade show" role="alert">
      Los beneficios que agregues o edites deberán ser aprobados por un
      administrador
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { BeneficioFacade as Facade } from "../../service/comerciante/beneficio/beneficio.facade";
import BeneficioLogic from "../../data/logica/beneficio";
import { BeneficioPendingFacade as PendingFacade } from "../../service/comerciante/beneficio/beneficio-pending.facade";
import { BeneficioRechazadosFacade as RechazadosFacade } from "../../service/comerciante/beneficio/beneficio-rechazados.facade";
import FormularioBeneficio from "../panel/formularios/FormularioBeneficio.vue";
import { Icons as IconConstants } from "../../constants";
import ModalCrud from "../panel/modals/ModalCrud.vue";
import Tabla from "../panel/tablas/Tabla.vue";

export default {
  components: {
    FontAwesomeIcon,

    FormularioBeneficio,
    ModalCrud,
    Tabla,
  },
  computed: {
    Columnas() {
      return BeneficioLogic.ColumnasComerciante;
    },
    ColumnasRechazados() {
      return BeneficioLogic.ColumnasComercianteRechazados;
    },
    Facade() {
      return Facade;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    PendingFacade() {
      return PendingFacade;
    },
    RechazadosFacade() {
      return RechazadosFacade;
    },
  },
  methods: {
    abrir(item) {
      this.$refs.modal.abrir(item);
    },
    eliminado(item) {
      // Informar a ambas tablas ya que no sabemos en cual estaba
      this.$refs.tablaAprobados.eliminado(item);
      this.$refs.tablaPendientes.eliminado(item);
      this.$refs.tablaRechazados.eliminado(item);
    },
    guardado(item) {
      // Siempre que se guarda pasará a la tabla de pendientes
      this.$refs.tablaAprobados.eliminado(item);
      this.$refs.tablaPendientes.guardado(item);
      this.$refs.tablaRechazados.eliminado(item);
      Swal.fire(
        "Guardado",
        "Tu beneficio fue guardado y está pendiente de aprobación",
        "success"
      );
    },
    nuevo() {
      this.$refs.modal.abrir();
    },
    async onSavingError(error) {
      try {
        if (error.response) {
          const data = error.response.data;
          if (data) {
            if (
              data.message ===
              "BENEFICIO_DISCOUNT_PERCENTAGE_BELOW_MINIMUM_ERROR"
            ) {
              let messageText;

              try {
                const minimumDiscountPercentage = (
                  await Facade.getMinimumDiscountPercentage()
                ).data;

                messageText = `El porcentaje de descuento no puede ser menor
                 al mínimo para este comercio (${minimumDiscountPercentage}%)`;
              } catch (error) {
                // An error when obtaining the minimum. Still show information, without the minimum percentage
                messageText =
                  "El porcentaje de descuento no puede ser menor al mínimo para este comercio";
              }

              return Swal.fire({
                icon: "error",
                title: "Error",
                text: messageText,
              });
            }
          }
        }
      } catch (error) {
        return Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ocurrió un error inesperado",
        });
      }

      return Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error inesperado",
      });
    },
    limpiarValorDescuento() {
      this.$refs.formularioBeneficio.limpiarValorDescuento();
    }
  },
  mounted() {
    const myModal = document.getElementById('modalcrud')
    myModal.addEventListener('hidden.bs.modal', () => {
      this.limpiarValorDescuento();
    });
  }
};
</script>
